import { SOURCE_VALUES } from "../../../subscription-contract/constants.js";
function addError(errors, key, message) {
    errors[key] ??= [];
    if (!errors[key].includes(message))
        errors[key].push(message);
}
export function getSkuValidationError(contract, errors, validSkus) {
    if (contract.source !== SOURCE_VALUES.TM)
        return errors;
    const sku = (contract.sku ?? "").trim().toLowerCase();
    if (!sku)
        return errors;
    if (!validSkus.has(sku)) {
        addError(errors, "sku", "Ugyldig kampanjekode/SKU (Finnes ikke som abonnement-variant i Crystallize)");
    }
    return errors;
}
